"use client";

import { useEffect, useState } from "react";

function readConsentStatus(
  serviceName: string,
  categorySlug?: string
): boolean {
  const services = window.UC_UI?.getServicesBaseInfo?.() ?? [];
  const filtered = categorySlug
    ? services.filter((s) => s.categorySlug === categorySlug)
    : services;

  return filtered.find((s) => s.name === serviceName)?.consent?.status ?? false;
}

export function useUsercentricsConsent(
  serviceName: string,
  categorySlug?: string
): boolean | null {
  const [consented, setConsented] = useState<boolean | null>(null);

  useEffect(() => {
    if (window.UC_UI?.isInitialized?.()) {
      setConsented(readConsentStatus(serviceName, categorySlug));
    }

    const refresh = () =>
      setConsented(readConsentStatus(serviceName, categorySlug));

    window.addEventListener("UC_UI_INITIALIZED", refresh);
    window.addEventListener("UC_UI_CMP_EVENT", refresh);

    return () => {
      window.removeEventListener("UC_UI_INITIALIZED", refresh);
      window.removeEventListener("UC_UI_CMP_EVENT", refresh);
    };
  }, [serviceName, categorySlug]);

  return consented;
}
